export const INIT = 'INIT'
export const EDIT = 'EDIT'
export const MEMO = 'MEMO'
export const ACCOMMODATION = 'UPDATE-ACCOMMODATION-PRICE'
export const UNCOLLECTED = 'UNCOLLECTED'
export const LOAD_PLAN = 'LOAD-PLAN'
